import { ErrorCode } from '@ps/web-core-enums';
import { useTrackers } from '@ps/web-shared-analytics';
import type { Errors } from '@ps/web-shared-validators';
import { isEqual, uniqWith } from 'lodash';
import type { ReactNode } from 'react';
import type React from 'react';
import type { FieldInputProps } from 'react-final-form';

import PowMessage from '../../PowMessage/PowMessage';
import ValidationTip from '../../ValidationTip/ValidationTip';
import { RawButton } from '../../buttons/index';

import styles from './InputValidationMessages.module.scss';

interface Props {
  dirty: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input: FieldInputProps<any, HTMLElement>;
  validations: Errors | undefined;
}

const InputValidationMessages: React.FC<Props> = (props) => {
  const validations = uniqWith(props.validations, isEqual) as Errors;
  const { buttonPressed } = useTrackers();
  const { dirty, input } = props;
  const suggestions = validations.find(
    (validation) => !!(validation?.suggestedNames && validation.suggestedNames.length)
  )?.suggestedNames;

  if (!validations) {
    return null;
  }

  return (
    <>
      <ul className={styles.validationTips}>
        {validations
          .filter((validation) => !!validation.message)
          .map((validation, i) => {
            const message =
              validation.code !== ErrorCode.POW_REQUIRED ? (
                validation.message
              ) : (
                <PowMessage title={validation.message as ReactNode} />
              );

            return (
              <ValidationTip
                key={i}
                element="li"
                message={message}
                dirty={dirty}
                valid={validation.valid}
              />
            );
          })}
      </ul>
      {!!suggestions && (
        <div className={styles.suggestions}>
          {suggestions.map(
            (suggestion) =>
              !!suggestion && (
                <RawButton
                  className={styles.suggestion}
                  key={suggestion}
                  onClick={() => {
                    buttonPressed({ buttonName: 'Suggestion' });
                    input.onChange(suggestion);
                  }}
                  variant="secondary"
                >
                  {suggestion}
                </RawButton>
              )
          )}
        </div>
      )}
    </>
  );
};

export default InputValidationMessages;
